import { formaters } from "vincent-utils";
import { aptRequestCommitSchema, CadendarConsts } from "cadendar-shared";
import _ from "underts";
import {
  useMinAptDuration,
  useRdvPopupState,
  useSelectedAptRequest,
  useSelectedWeek,
} from "../../main/state/globalState";
import useSelectedPatients from "../../patients/hooks/useSelectedPatients";
import useOwner from "../../users/hooks/useOwner";
import { useHoraire } from "../../horaires/hooks/useHoraire";
import { trpc } from "../../main/components/trpc.ts";
import { Transforms } from "cadendar-shared";
import HSelectGroup from "../../main/components/HSelectGroup.tsx";
import Select2 from "../../../components/Select2.tsx";
import Select from "../../../components/Select.tsx";
import VInputGroup from "../../main/components/VInputGroup.tsx";
import CheckBox from "../../main/CheckBox.tsx";
import {Button} from "@/components/ui/button";
import styles from "./AptRequestComp.module.css";
import { FaRegCopy } from "react-icons/fa";
import InputIcon from "../../main/components/InputIcon.tsx";
import classNames from "classnames";
import { useForm } from "@tanstack/react-form";

const idToLink = (_id: string) => {
  return `https://patients.cadendar.com/aptRequestLink?id=${_id}`;
};

const AptRequestComp = () => {
  //data from selectors
  //const patientSelected = patientsStore.selectedPatient;
  const patientsSelected = useSelectedPatients();
  const patientSelected = _.first(patientsSelected);
  const npDisplay = (patientSelected?.name &&
    formaters.formatNameForenameForDisplay(patientSelected)) || {
    name: "PAS DE PATIENT SéLECTIONNé".toLocaleUpperCase(),
    forename: "",
  };
  const { selectedWeek } = useSelectedWeek();
  const duréeMiniRdv = useMinAptDuration();
  const horaire = useHoraire(selectedWeek);
  const maxLength = horaire
    ? Transforms.horaires.longestRdvPossible(horaire)
    : 0;
  const dureesPossibles = _.range(
    duréeMiniRdv,
    maxLength + duréeMiniRdv,
    duréeMiniRdv
  );
  console.log("dureesPossibles", dureesPossibles);
  const typesPossibles = CadendarConsts.typesNames;
  const owner = useOwner();
  const { aptRequest, onSelectAptRequestId } = useSelectedAptRequest();
  console.log("aptRequest", aptRequest);

  const form = useForm({
    defaultValues: {
      duration: aptRequest?.duration || duréeMiniRdv,
      type: aptRequest?.type || 1,
      object: aptRequest?.object || "",
      public_object: aptRequest?.public_object || "",
      reminder_checked: aptRequest?.reminder_checked || false,
      confirm_checked: aptRequest?.confirm_checked || false,
      patient_id: patientSelected?.id || null,
      id: aptRequest?.id || undefined,
    },
    onSubmit: (values) => {
      const patient_id = patientSelected?.id || null;
      if (!patient_id) {
        throw new Error("no patient selected in RdvRequest handleSubmit");
      }
      const remindersAllowed = patientSelected
        ? Transforms.patients.hasRemindersTargets(patientSelected)
        : false;
      const confirmationsAllowed = patientSelected
        ? Transforms.patients.hasConfirmationTarget(patientSelected)
        : false;
      const obj = {
        ...values.value,
        canceled: aptRequest?.canceled || false,
        patient_id,
        reminder_checked: remindersAllowed ? values.value.reminder_checked : false,
        confirm_checked: confirmationsAllowed
          ? values.value.confirm_checked
          : false,
        ...(aptRequest?.owner ? { owner } : {}),
        ...(aptRequest?.id ? { id: aptRequest.id } : {}),
        ...(aptRequest?.owner ? { apt_id: aptRequest.apt_id || null } : {}),
      };
      if (!aptRequest) {
        delete obj.id;
      }
      console.log("obj", obj);
      const validated = aptRequestCommitSchema.safeParse(obj);
      console.log("validated", validated);
      if (!validated.success) {
        console.log("validated.error", validated.error);
        return;
      }
      commitAptRequestMutation.mutate(validated.data);
    },
  });

  // const [tempAptRequest, setTempAptRequest] = useState<AptRequestCommitDTO>(
  //   getDefaultAptRequest(duréeMiniRdv, patientSelected?.id || "")
  // );

  // useEffect(() => {
  //   if (aptRequest) {
  //     setTempAptRequest(aptRequest);
  //   }
  // }, [JSON.stringify(aptRequest)]);

  // const handleDureeChange = (dureeStr: string) => {
  //   setTempAptRequest((aptRequest) => ({
  //     ...aptRequest,
  //     length: parseInt(dureeStr),
  //   }));
  // };

  // const handleTypeChange = (type: string) => {
  //   setTempAptRequest((aptRequest) => ({
  //     ...aptRequest,
  //     type: CadendarConsts.getTypeNumberFromTypeName(
  //       type as (typeof typesPossibles)[number]
  //     ),
  //   }));
  // };

  // const handleObjectChange = (objet: string) => {
  //   setTempAptRequest((aptRequest) => ({
  //     ...aptRequest,
  //     object: objet,
  //   }));
  // };

  // const handlePublicObjectChange = (objet: string) => {
  //   setTempAptRequest((aptRequest) => ({
  //     ...aptRequest,
  //     publicObject: objet,
  //   }));
  // };

  const confirmCheckBoxEnabled = patientSelected
    ? Transforms.patients.hasConfirmationTarget(patientSelected)
    : false;

  const remindersCheckBoxEnabled = patientSelected
    ? Transforms.patients.hasRemindersTargets(patientSelected)
    : false;
  // const onToggleConfirmChecked = () => {
  //   setTempAptRequest((aptRequest) => ({
  //     ...aptRequest,
  //     confirm_checked: !aptRequest.confirm_checked,
  //   }));
  // };

  // const onToggleReminderChecked = () => {
  //   setTempAptRequest((aptRequest) => ({
  //     ...aptRequest,
  //     reminder_checked: !aptRequest.reminder_checked,
  //   }));
  // };
  // const link = aptRequest?.id ? idToLink(aptRequest.id) : "";

  // const hasChanges =
  //   tempAptRequest.duration !== aptRequest?.duration ||
  //   tempAptRequest.type !== aptRequest?.type ||
  //   tempAptRequest.object !== aptRequest?.object ||
  //   tempAptRequest.public_object !== aptRequest?.public_object ||
  //   tempAptRequest.reminder_checked !== aptRequest?.reminder_checked ||
  //   tempAptRequest.confirm_checked !== aptRequest?.confirm_checked;

  const trpcUtils = trpc.useUtils();
  const commitAptRequestMutation = trpc.aptRequest.commit.useMutation({
    onSuccess: (id) => {
      if (id) {
        onSelectAptRequestId(id);
      }
      form.reset();
    },
    onSettled: () => {
      trpcUtils.aptRequest.invalidate();
    },
  });
  // const handleSubmit = () => {
  //   if (!owner) {
  //     throw new Error("no owner in handleSubmit in RdvRequest component");
  //   }
  //   if (!patientSelected) {
  //     throw new Error("no patient selected in RdvRequest handleSubmit");
  //   }
  //   commitAptRequestMutation.mutate(tempAptRequest);
  // };
  const { onCloseRdvPopup } = useRdvPopupState();
  const handleCancel = () => {
    onCloseRdvPopup();
  };

  const deleteAptRequestMutation = trpc.aptRequest.delete.useMutation({
    onSettled: () => {
      trpcUtils.aptRequest.invalidate();
    },
    onSuccess: () => {
      onCloseRdvPopup();
    },
  });
  const handleDelete = () => {
    aptRequest && deleteAptRequestMutation.mutate(aptRequest.id);
  };

  // const isNew = !("_id" in tempAptRequest);

  const dureeKeyMap = dureesPossibles.reduce(
    (acc, d) => {
      acc[d.toString()] = d.toString();
      return acc;
    },
    {} as { [key: string]: string }
  );

  return (
    <div className={styles.width400}>
      <div className="bg-[#545454] text-white text-center m-[1px] select-none">
        {npDisplay.name + " " + npDisplay.forename}
      </div>
      <div>
        <form.Field
          name="duration"
          children={(field) => (
            <>
              <HSelectGroup label="Durée" id="duree_chooser" labelWidth="20%">
                <Select2
                  keyMap={dureeKeyMap}
                  onSelect={(value: string) =>
                    field.handleChange(parseInt(value))
                  }
                  selected={field.state.value.toString()}
                  defaultKey={""}
                  className={""}
                  id={"duree_chooser"}
                />
              </HSelectGroup>
            </>
          )}
        />
        <form.Field
          name="type"
          children={(field) => (
            <>
              <HSelectGroup label="Type" labelWidth="20%" id="type_chooser">
                <Select
                  className=""
                  labels={typesPossibles.sort()}
                  selected={CadendarConsts.getTypeNameFromTypeNumber(
                    field.state.value
                  )}
                  onSelect={(value: string) =>
                    field.handleChange(
                      CadendarConsts.getTypeNumberFromTypeName(
                        value as (typeof typesPossibles)[number]
                      )
                    )
                  }
                  id={"type_chooser"}
                />
              </HSelectGroup>
            </>
          )}
        />
        <form.Field
          name="object"
          children={(field) => (
            <VInputGroup
              label={"Objet interne (non communiqué au patient)"}
              value={field.state.value}
              onChange={field.handleChange}
              id="rdv_objet_field"
            />
          )}
        />
        <form.Field
          name="public_object"
          children={(field) => (
            <VInputGroup
              label={"Objet public (communiqué au patient)"}
              value={field.state.value}
              onChange={field.handleChange}
              id="rdv_public_object_field"
            />
          )}
        />
        <form.Field
          name="reminder_checked"
          children={(field) => (
            <CheckBox
              label="Envoyer MAIL/SMS"
              checked={remindersCheckBoxEnabled ? field.state.value : false}
              onChange={(val) => field.handleChange(val)}
              disabled={!remindersCheckBoxEnabled}
              id={
                remindersCheckBoxEnabled
                  ? "send_reminder"
                  : "send_reminder_disabled"
              }
            />
          )}
          listeners={{
            onChange: (e) => {
              console.log("onChange", e);
            },
          }}
        />
        <form.Field
          name="confirm_checked"
          children={(field) => (
            <CheckBox
              checked={confirmCheckBoxEnabled ? field.state.value : false}
              onChange={field.handleChange}
              disabled={!confirmCheckBoxEnabled}
              label="Demander Confirmation"
              id={
                confirmCheckBoxEnabled
                  ? "send_confirm"
                  : "send_confirm_disabled"
              }
            />
          )}
        />

        <form.Subscribe
          selector={(state) => ({
            canSubmit: state.canSubmit,
            isSubmitting: state.isSubmitting,
            isNew: !state.values.id,
            link: state.values.id ? idToLink(state.values.id) : "",
            hasChanges: state.isDirty,
          })}
          children={({ canSubmit, isSubmitting, isNew, link, hasChanges }) => (
            <>
              <div className={styles.verticalSpacer}>
                <div className={styles.horizontalSpacer}>
                  {isNew ? (
                    <Button
                      onClick={form.handleSubmit}
                      id="createLinkButton"
                      disabled={!canSubmit || isSubmitting}
                    >
                      Créer lien
                    </Button>
                  ) : null}
                  {link ? (
                    <div
                      className={classNames(
                        styles.verticalSpacer,
                        styles.width100
                      )}
                    >
                      <label className="">Lien à copier</label>
                      <InputIcon
                        value={link}
                        onChange={() => {}}
                        onClick={() => navigator.clipboard.writeText(link)}
                        readonly={true}
                        id="copyLinkButton"
                      >
                        <FaRegCopy size="1.3rem" />
                      </InputIcon>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className={styles.horizontalSpacer}>
                {hasChanges ? (
                  <>
                    {!isNew ? (
                      <Button
                        onClick={form.handleSubmit}
                        id="button_save_aptRequest"
                        disabled={!canSubmit || isSubmitting}
                      >
                        Enregistrer
                      </Button>
                    ) : null}
                    <Button
                      onClick={() => form.reset()}
                      variant="secondary"
                      id="button_cancel_save_aptRequest"
                    >
                      Annuler
                    </Button>
                  </>
                ) : (
                  <Button
                    onClick={onCloseRdvPopup}
                    id={"button_close_AptRequestComp"}
                  >
                    Ok
                  </Button>
                )}
                {aptRequest ? (
                  <Button
                    onClick={handleDelete}
                    variant="destructive"
                    id={"button_delete_AptRequest"}
                  >
                    Supprimer lien
                  </Button>
                ) : null}
              </div>
            </>
          )}
        />
      </div>
    </div>
  );
};

export default AptRequestComp;
